import React, { FC, useMemo } from "react";
import memoize from "utils/memoize";
import {
  RHFormConsumerTextField,
  RHFormConsumerTextFieldProps
} from "component-rh-text-field/RHFormConsumerTextField";
import {
  allAvailableStates,
  caStates,
  State,
  usStates
} from "utils/formHelpers";
import { usePageContent } from "customProviders/LocationProvider";

export const StateSelectField: FC<
  RHFormConsumerTextFieldProps & { countryCode?: string; stateList?: State[] }
> = ({ countryCode, stateList: stateListProp, ...props }) => {
  // If no country code is specified then combine US and Canadian states since that's how it currently implemented everywhere else
  const stateList = useMemo<State[]>(() => {
    if (countryCode) {
      return allAvailableStates[countryCode];
    } else if (stateListProp) {
      return stateListProp;
    } else {
      return [...usStates, ...caStates].sort((a, b) =>
        a.code > b.code ? 1 : -1
      );
    }
  }, [countryCode, stateListProp]);
  const { pageContent } = usePageContent();
  return (
    <RHFormConsumerTextField
      defaultValue=""
      name={"state"}
      fullWidth
      select={(stateList || []).length > 0}
      label={props.label || (countryCode === "GB" ? "County" : "State")}
      autoComplete="address-level1" // MDN FIREFOX: https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete
      {...props}
      rules={{
        ...(props?.rules || {}),
        required:
          (props.required || props?.rules?.required) && !!stateList?.length
            ? props.errorMessages?.["stateRequired"] ||
              `${countryCode === "GB" ? "County" : "State"} required.`
            : null
      }}
    >
      {(stateList || []).length > 0 && <option value=""></option>}
      {stateList &&
        (stateList || []).length > 0 &&
        stateList.map(state => (
          <option
            key={`state-${state.code}-${Math.random()}`}
            value={state.code}
          >
            {state.code} - {state.name}
          </option>
        ))}
    </RHFormConsumerTextField>
  );
};

export default memoize(StateSelectField);
